import React, {useEffect, useState} from "react";
import {MDBDataTable} from "mdbreact";
import {Actions} from "../../../client/Actions";
import {useHistory} from "react-router-dom";
import {Badge, Col, Form, Row} from "react-bootstrap";
import FileModal from "../FileModal";
import ConfirmModal from "../modal/ConfirmModal";
import IconButton from "../button/IconButton";
import QrCode from "../qrCode/QrCode";
import renderUtils from "../../helpers/renderUtils";
import BtnSliderRoundedComponent from "../switch/BtnSliderRoundedComponent";
import TooltipImage from "../tooltip/TooltipImage";
import utils from "../../helpers/utils";
import Tooltip from "../tooltip/Tooltip";
import CardForm from "../form/CardForm";
import { useTranslation } from 'react-i18next';

const Table = ({
                   source,
                   columns,
                   setLoader,
                   pagination,
                   initData,
                   checked,
                   setChecked,
                   showAlways,
                   providedData,
                   tableHeader,
                   disableRule,
                   reload,
                   striped,
                   conditionalRowStyles,
                   additionalFilter,
                   externalState,
                   setExternalState,
                   externalState2,
                   onReload,
                   searchConf,
                   readOnly
               }) => {

    const { t } = useTranslation();

    const history = useHistory();

    const [filePresentation, setFilePresentation] = useState({});
    const [textareaPresentation, setTextareaPresentation] = useState({});
    const [qrCodePresentation, setQrCodePresentation] = useState({});
    const [internalReload, setInternalReload] = useState(false);
    const [locked, setLocked] = useState([]);
    const [cachedResponse, setCachedResponse] = useState();
    const [searchFormConf, setSearchFormConf] = useState();
    const [filters, setFilters] = useState([]);


    const filterSlider = (filter, check) => {
        setChecked((prevChecked) => {
            if (!check || prevChecked.find(f => f.id === filter.id)) {
                return prevChecked.filter(c => c.id !== filter.id);
            } else {
                return [...prevChecked, filter];
            }
        });
    };

    const filterChecked = (filter) => {
        setChecked((prevChecked) => {
            if (prevChecked.find(f => f.id === filter.id)) {
                return prevChecked.filter(c => c.id !== filter.id);
            } else {
                return [...prevChecked, filter];
            }
        });
    };


    function handleShowFileModal(title, files) {

        setFilePresentation({
            title: title,
            files: files,
            show: true
        });
    }

    function handleShowQrCodeModal(qrCode) {

        setQrCodePresentation({
            value: qrCode,
            show: true
        });
    }

    function handleShowTextAreaModal(title, files) {

        setTextareaPresentation({
            title: title,
            value: files,
            show: true
        });
    }

    const [data, setData] = useState({
        rows: [],
        columns: columns.filter(c => !readOnly || showAlways?.includes(c.field) ? true : !c.hideForReadonly)
            .filter(c => c.hasAccess ? c.hasAccess() : true)
            .map(c => {
                if (c.field === "actions") {
                    c.className = "print-hide"
                }
                return c;
            })
    });

    function reloadChecked() {
        if (initData) {
            reloadData();
        }
        if (cachedResponse) {
            onDataLoaded(cachedResponse)
        }
    };

    function reloadData() {
        console.log("Starting reload table data, initData: ", initData)
        if (onReload) {
            onReload()
        }
        if (initData) {
            onDataLoaded(initData);
        } else if (source) {
            setLoader(true);
            Actions.get(source, onDataLoaded);
        }
    };

    const onDataLoaded = (response) => {
        const result = response.filter(row =>
            filters.length > 0
                ? filters.every(filterFunction => filterFunction(row))
                : true
        );

        setCachedResponse(result);

        setData({
            ...data,
            rows: prepareRows(result)
        });

        setLoader(false);
    };
    const prepareSearchFormConf = () => {
        if (searchConf) {
            const fields = [];
            searchConf.forEach(conf => {
                if (conf.searchType === "range") {
                    fields.push({
                        name: conf.field + "_from",
                        label: columns.find(c => c.field === conf.field).label + " od",
                        type: conf.fieldType,
                        column: 1,
                        searchConf: {
                            field: conf.field,
                            compareType: "gt"
                        }
                    })
                    fields.push({
                        name: conf.field + "_to",
                        label: columns.find(c => c.field === conf.field).label + " do",
                        type: conf.fieldType,
                        column: 2,
                        searchConf: {
                            field: conf.field,
                            compareType: "lt"
                        }
                    })
                }

                if (conf.searchType === "contains") {
                    fields.push({
                        name: conf.field,
                        label: columns.find(c => c.field === conf.field).label,
                        type: conf.fieldType,
                        column: 1,
                        searchConf: {
                            field: conf.field,
                            compareType: conf.searchType
                        }
                    })
                }
            })

            setSearchFormConf({
                config: {columns: 2},
                fields: fields
            })
        }
    };

    const search = (searchForm) => {
        const tmpFilters = []

        Object.keys(searchForm).forEach(key => {
                const fieldConf = searchFormConf.fields.find(c => c.name === key)
                const searchValue = searchForm[key];
                if (fieldConf && fieldConf.searchConf && searchValue && searchValue !== "") {
                    tmpFilters.push((row) => {
                        let fieldType = fieldConf.type;
                        let compareType = fieldConf.searchConf.compareType;
                        let fieldName = fieldConf.searchConf.field;
                        if (compareType === "gt") {
                            let fieldValue = row[fieldName]

                            if (fieldType === "date") {
                                return new Date(fieldValue) >= new Date(searchValue)
                            }

                        }

                        if (compareType === "lt") {
                            let fieldValue = row[fieldName]

                            if (fieldType === "date") {
                                return new Date(fieldValue) <= new Date(searchValue)
                            }

                        }
                        return true;

                    })
                }
            }
        )
        setFilters(tmpFilters)
    };

    useEffect(reloadData, [internalReload, locked, reload, initData, filters, externalState, externalState2]);
    useEffect(reloadChecked, [checked]);
    useEffect(prepareSearchFormConf, [searchConf]);


    const prepareRows = (response) => {
        return response
            .filter(r => additionalFilter ? additionalFilter(r) : true)
            .map((r, i) => prepareRow(i, r));
    };


    const extractText = (value) => {
        if (typeof value === 'string' || typeof value === 'number') {
            // Return string or number as a string
            return String(value);
        } else if (React.isValidElement(value)) {
            // Render the JSX to extract text from children
            return React.Children.toArray(value.props.children).map(extractText).join(' ');
        } else if (typeof value === 'object') {
            // Handle the case where value is an object
            return JSON.stringify(value);
        }
        return '';
    };

    const prepareRow = (i, row) => {
        let result = {};
        let searchValue = "";

        columns.forEach(column => {
            let preparedValue = column.render
                ? column.render(row)
                : prepareValue(column, i, column.parent ? row[column.parent] || {} : row);

            result[column.field] = wrapValue(preparedValue, column, row);

            const text = extractText(preparedValue);
            if (text) {
                searchValue += text;
            }
        });

        result.searchValue = searchValue;

        return result;
    };

    function buildQrCodeModalComponent(column, row) {

        return (<IconButton
            variant="outline-primary"
            onClick={() => handleShowQrCodeModal(row[column.qrCode])}
            icon="fa-qrcode"
            tooltip="Kod QR"
        />);
    }

    const prepareValue = (column, i, row) => {


        const value = row[column.field];
        let {field, type, label, enumType} = column;


        if (type === "dictionary") {
            if (value) {
                return value.name;
            }
            return undefined;

        }

        if (type === "index") {
            return i + 1;
        }

        if (type === "length") {
            return value ? value.length : 0;
        }


        if (type === "boolean") {
            if (value === true) {
                return t("common.yes");
            }

            if (value === false) {
                return t("common.no");
            }

            return undefined;
        }

        if (type === "enum") {
            return renderUtils.renderEnumName(value, enumType, t);
        }

        if (type === "custom") {
            if (readOnly && column.textForReadOnly) {

            } else {
                return column.custom(column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState, externalState2, setExternalState);

            }
        }

        if (type === "file") {
            return buildModalComponent(
                row,
                (row) => row[field] && row[field].length > 0,
                column,
                () => handleShowFileModal(label, row[field])
            );
        }


        if (type === "textarea") {
            return buildTextAreaComponent(
                row,
                (row) => row[field],
                (row) => row[field] && row[field] !== "",
                column,
                () => handleShowTextAreaModal(label, row[field])
            );
        }

        if (type === "qrCode") {
            return buildQrCodeModalComponent(column, row);
        }

        if (type === "checkbox") {
            return buildTableCheckbox(row);
        }

        if (type === "slider") {
            return buildTableSlider(row);
        }


        if (type === "lock") {
            return buildTableLock(row);
        }

        if (type === "tooltipImage") {
            return buildImageTooltip(row, column, value);
        }

        return value;

    };

    function buildTableCheckbox(row) {
        return <div id={"checkbox-" + row.id} className="">
            <label className="checkbox-container">
                <input type="checkbox" disabled={readOnly}
                       checked={readOnly ? checked.includes(row.id) : checked.some(c => c.id === row.id)}
                       onChange={() => filterChecked(row)}/>
                <span className="checkmark"></span>
            </label>
        </div>;
    }

    function buildImageTooltip(row, column, value) {
        const image = column.resolveImage ? column.resolveImage(row) : undefined;

        if (!image) {
            return value;
        }

        return <TooltipImage
            filePath={image.filePath}
            fileName={image.fileName}
        >
            <>{value}</>
        </TooltipImage>;


    }

    function buildTableLock(row) {
        if (!locked.find(l => l === row.id)) {
            return <IconButton icon="fa-lock-open"
                               className={"btn-circle"}
                               color="primary"
                               onClick={() => {
                                   setLocked(old => [...old, row.id]);
                               }
                               }
                               tooltip={t("tooltips.lock")}/>;
        } else {
            return <IconButton icon="fa-lock" color="primary"
                               className={"btn-circle"}

                               onClick={() => setLocked(locked.filter(l => l !== row.id))}
                               tooltip={t("tooltips.unlock")}/>;
        }

    }

    function buildTableSlider(row) {
        const lock = locked.find(l => l === row.id);
        const isChecked = checked.find(c => c.id === row.id);

        return <div className={lock ? "opacity-30" : ""}>
            <BtnSliderRoundedComponent checked={isChecked}

                                       setState={(check) => filterSlider(row, check)}
                                       disabled={lock || readOnly} red={!isChecked}/>
        </div>;
    }

    function buildModalComponent(row, isAdded, column, onClick) {

        return (
            <>
                {!isAdded(row) &&

                    <Form.Row>
                        <Col>
                            <Form.Label className="col-form-label text-warning">
                                {t("common.not_added")}
                            </Form.Label>
                        </Col>
                    </Form.Row>
                }
                {isAdded(row) &&

                    <Form.Row>
                        <Col>
                            <Form.Label className="col-form-label cursor-pointer"
                                        onClick={onClick}>{t("common.added")}&nbsp;
                                <span className="text-success">
                  <i className="fas fa-info-circle"/>
                </span>
                            </Form.Label>
                        </Col>
                    </Form.Row>
                }
            </>
        );
    }

    function buildTextAreaComponent(row, getValue, isAdded, column, onClick) {

        return (
            <>
                {!isAdded(row) &&

                    <Form.Row>
                        <Col>
                            <Form.Label className="col-form-label text-warning">
                                -
                            </Form.Label>
                        </Col>
                    </Form.Row>
                }
                {isAdded(row) &&

                    <Tooltip tooltip={t("common.more")}>
                        <span onClick={onClick}
                              className={"cursor-pointer"}>{utils.truncateText(getValue(row), 7)}</span>
                    </Tooltip>
                }
            </>
        );
    }


    const wrapValue = (value, column, row) => {

        if (value !== 0 && !value) {
            return "-";
        }

        if (column.type !== "custom" && disableRule && disableRule(row)) {
            return <div className={"disabled"}>{value}</div>;
        } else if (column.type === "badge") {
            return <Badge
                className={(column.badgeType ? column.badgeType : "outline-secondary") + " font-max"}>{value}</Badge>;
        } else
            return value;
    };


    return (
        <>
            {
                searchFormConf &&
                <Row className={"print-hide"}>
                    <CardForm
                        fields={searchFormConf}
                        title={t("forms.search")}
                        saveButton={t("forms.search")}
                        width={12}
                        reverseButtons={true}
                        customSave={search}
                        setLoader={setLoader}
                    />
                </Row>
            }
            <MDBDataTable
                className={`
                ${pagination === false ? "no-pagination-table" : ""}
                ${tableHeader === false ? "hide-headers" : ""}
                 `}
                striped={striped ? striped : false}
                searchLabel={t("forms.search")}
                infoLabel={[t("common.shown_from"), t("common.to"), t("common.of"), ""]}
                entriesLabel={t("common.show")}
                noRecordsFoundLabel={t("common.none")}
                paginationLabel={["«", "»"]}
                paging={pagination !== false}
                searching={pagination !== false}
                data={data}
                onSearch={value => console.log(value)}
                conditionalRowStyles={conditionalRowStyles}
            />

            {filePresentation &&
                <FileModal
                    title={filePresentation.title}
                    show={filePresentation.show}
                    setShow={() => setFilePresentation(undefined)}
                    files={filePresentation.files}
                    setFiles={() => {
                    }}
                />
            }

            {textareaPresentation &&
                <ConfirmModal
                    title={textareaPresentation.title}
                    size={"md"}
                    show={textareaPresentation.show}
                    setShow={() => setTextareaPresentation(undefined)}
                    alert
                    children={
                        <>
                            <Form.Group>
                                <Form.Control
                                    as={"textarea"}
                                    disabled={true}
                                    value={textareaPresentation.value}
                                    type="text"
                                />
                            </Form.Group>
                        </>

                    }
                />
            }


            {qrCodePresentation &&
                <ConfirmModal
                    title={t("common.qr_code")}
                    size={"md"}
                    show={qrCodePresentation.show}
                    setShow={() => setQrCodePresentation(undefined)}
                    alert
                    children={

                        <Row className="justify-content-center">
                            <QrCode e value={qrCodePresentation.value} filePrefix={"filterSet"}/>
                        </Row>

                    }
                />
            }
        </>
    );
};

export default Table;